var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"page-container"},[_vm._v("没有找到你要的页面"),_c('br'),_vm._v("你是不是迷路了? "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("点击返回首页 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }